module.exports = __webpack_public_path__ + "img/BSB_13_L_age26-Marissa.0f16b2a1.jpg";